import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        wWidth: document.body.clientWidth,
        wHeight: document.body.clientHeight,
        isMobile: false,
        deviceTypePC: true, // true = PC, false = MOBILE 
        spNo: null,
        viewType: 'application',
        verifyForm: {},
        personalType: '',
        serviceType: '',
        form: {
            quota: {
                macauAddress: {
                    textCn: "",
                    textPt: ""
                }
            },
            vehicle: {},
            cheque: {},
            drivers: [{
                macauAddress: {
                    textCn: "",
                    textPt: ""
                }
            }]
        },
        vssForm: {
            spRemark: {}
        },
        documentType: [],
        firstApplicationCheck: false,
        simpleData: {},
        serviceTypeConfig: {},
        isApp: false,
        taxiApplication: {},
        drivApplication: {}
    },
    getters: {},
    mutations: {
        changeWidth(state, result) {
            state.wWidth = result;
            state.isMobile = result < 768 ? true : false;
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                state.deviceTypePC = false;
            } else {
                state.deviceTypePC = true;
            }
        },
        changeHeight(state, result) {
            state.wHeight = result;
        },
        changePersonalType(state, result) {
            state.personalType = result;
        },
        changeServiceType(state, result) {
            state.serviceType = result;
        },
        updateForm(state, result) {
            state.form = result;
        },
        changeVssForm(state, result) {
            state.vssForm = {
                ...result,
                spRemark: result.spRemark ? result.spRemark : {}
            }
        },
        changeFirstApplicationCheck(state, result) {
            state.firstApplicationCheck = result
        },
        // changeSpNo(state, result) {
        //     state.verifyForm.spNo = result
        // },
        changeViewType(state, result) {
            state.viewType = result
        },
        changeVerifyForm(state, result) {
            state.verifyForm = result
        },
        changeDocumentType(state, result) {
            state.documentType = result;
            localStorage.setItem('documentType', JSON.stringify(result));
        },
        changeSimpleData(state, result) {
            state.simpleData = result
        },
        changeServiceTypeConfig(state, result) {
            state.serviceTypeConfig = result
            // if (result) {
            //     delete state.form.cheque.amount
            //     state.form.cheque.amount = result.amount ? result.amount : 0
            // }
        },
        changeIsApp(state, result) {
            state.isApp = result;
        },
        // 的士准入信息
        changeTaxiApplication(state, result) {
            state.taxiApplication = result;
        },
        // 國際駕照准入信息
        changeDrivApplication(state, result) {
            state.drivApplication = result;
        }
    }

})

export default store